import { IReminderData, IReminderToDo } from './../personal_reminder_interface';
import { IStrategySafe, StrategySafe } from 'utility-ts-strategy';
import { ReminderListQuery } from './../queries/reminder_list_query';
import * as _4 from 'lodash4';

export class ReminderFilterServant {
  private strategy: IStrategySafe<any, string>;

  constructor(private ngReminderListQuery: ReminderListQuery, private TaskStatusEnum: any) {
    this.strategy = new StrategySafe<any, string>({
      allReminders: this.allReminders,
      remindersForToday: this.remindersForToday,
      upcomingReminders: this.upcomingReminders
    });
  }

  get filterStrategy(): IStrategySafe<any, string> {
    return this.strategy;
  }

  allReminders(): IReminderToDo[] {
    const reminders = _4.filter(this.ngReminderListQuery.result, (reminder) =>
      this.TaskStatusEnum.isActive(this.TaskStatusEnum.get(reminder.status))
    );
    return _4.map(reminders, (reminder: IReminderData) => {
      return {
        task: reminder
      };
    });
  }

  remindersForToday(): IReminderToDo[] {
    const endofDay: moment.Moment = moment().endOf('day');
    const currentTime: moment.Moment = moment();

    const reminders = _4.filter(this.ngReminderListQuery.result, (reminder: IReminderData) => {
      if (reminder.isAllDayReminder) {
        return (
          this.TaskStatusEnum.isActive(this.TaskStatusEnum.get(reminder.status)) &&
          moment(reminder.due_dt).isSame(moment(), 'day')
        );
      }
      return (
        this.TaskStatusEnum.isActive(this.TaskStatusEnum.get(reminder.status)) &&
        moment(reminder.due_ts || '').isBefore(endofDay) &&
        moment(reminder.due_ts || '').isAfter(currentTime)
      );
    });

    return _4.map(reminders, (reminder: IReminderData) => ({
      task: reminder
    }));
  }

  upcomingReminders(): IReminderToDo[] {
    const endofDay: moment.Moment = moment().endOf('day');

    const reminders = _4.filter(
      this.ngReminderListQuery.result,
      (reminder: IReminderData) =>
        this.TaskStatusEnum.isActive(this.TaskStatusEnum.get(reminder.status)) &&
        moment(reminder.due_ts || '').isAfter(endofDay)
    );

    return _4.map(reminders, (reminder: IReminderData) => ({
      task: reminder
    }));
  }
}

angular.module('data-ng-personal-reminders').service('ngReminderFilterServant', ReminderFilterServant);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-personal-reminders/src/services/reminder_filter_servant.ts